export default __webpack_public_path__ + "assets/419ef7a83f24c9db2cbcf4558366cc2d.png";